import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { FORGOT_PASSWORD, RESET_PASSWORD } from "config/apiPaths";

export const forgotPasswordApi = createApi({
    reducerPath: 'forgotPasswordApi',
    baseQuery: axiosBaseQuery({
        baseUrl: `/account`,
    }),
    endpoints: (builder) => ({
        forgotPassword: builder.mutation({
            query: (payload) => ({
                url: FORGOT_PASSWORD,
                method: 'POST',
                data: payload,
            })
        }),
        resetPassword: builder.mutation({
            query: ({ data, token }) => ({
                url: `${RESET_PASSWORD}/${token}`,
                method: 'POST',
                data,
            })
        })
    }),
});

export const {
    useForgotPasswordMutation,
    useResetPasswordMutation,
} = forgotPasswordApi;